import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAJbHnHRDuStcmg-svTTaS2tUGiU9TJKfQ",
    authDomain: "aerotubos-a3de6.firebaseapp.com",
    projectId: "aerotubos-a3de6",
    storageBucket: "aerotubos-a3de6.appspot.com",
    messagingSenderId: "1016258072618",
    appId: "1:1016258072618:web:e89968af753b29a336f353",
    measurementId: "G-5KZY6074TC"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };
